<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { ScheduleEvent } from '~/types'

interface Props {
  scheduleEvent: ScheduleEvent.Model
}

const props = defineProps<Props>()
const { isFinished, isLive, isPreGame } = useScheduleEvent(props.scheduleEvent)

const url = computed<RouteLocationRaw>(() => ({
  name: 'scores-scheduleEventId',
  params: {
    scheduleEventId: props.scheduleEvent.id,
  },
}))

const title = computed<Maybe<string>>(() => {
  if (isLive.value) {
    return 'Live Stats'
  }
  if (isFinished.value) {
    return 'Box Score'
  }
  return null
})
</script>

<template>
  <UIButton
    v-if="title && !isPreGame"
    :to="url"
    variant="outlined-dark"
    v-bind="$attrs"
  >
    {{ title }}
  </UIButton>
</template>
